import { render, staticRenderFns } from "./Song.vue?vue&type=template&id=4102ca95"
import script from "./Song.vue?vue&type=script&lang=js"
export * from "./Song.vue?vue&type=script&lang=js"
import style0 from "./Song.vue?vue&type=style&index=0&id=4102ca95&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports